import { call, put, takeEvery, takeLatest, delay } from "redux-saga/effects"
import toastr from "toastr"
import {
  GET_BLOGS,
  GET_BLOGS_BY_SLUG
  
} from "./actionTypes"
import {
  getBlogsFail,
  getBlogsSuccess,
  getBlogsBySlugFail,
  getBlogsBySlugSuccess
 
} from "./actions"

import {
  getBlogsApi,
  getBlogSlugApi
 
} from "helpers/backend_helper"

toastr.options = {
  newestOnTop: true,
  progressBar: true,
}

function* fetchBlogs({ payload }) {

  try {
    const response = yield call(getBlogsApi, payload)
    if (response.status == "failure") {
      return yield put(getBlogsFail(response.message))
    }
    yield put(getBlogsSuccess(response))
  } catch (error) {
    yield put(getBlogsFail(error))
  }
}


function* fetchBlogsBySlug({ payload: { data, callback } }) {

  try {
    const response = yield call(getBlogSlugApi, data)
    callback && callback(response);

    if (response.status == "failure") {
      return yield put(getBlogsBySlugFail(response.message))
    }
    yield put(getBlogsBySlugSuccess(response))
  } catch (error) {
    yield put(getBlogsBySlugFail(error))
  }
}



function* blogsSaga() {
  yield takeLatest(GET_BLOGS, fetchBlogs)
  yield takeLatest(GET_BLOGS_BY_SLUG, fetchBlogsBySlug)


}

export default blogsSaga
